import React, { useState } from 'react';

import Icon from 'components/commons/icon/Icon';
import MessageModal from './modal/MessageModal';

export const C_UpdateDataInfo = {
  title: 'データ更新のタイミングについて',
  message: [
    '証券口座のデータは平日の18：00以降に取得します。証券会社や取引データの量により反映までお時間がかかることがあります。データの反映まで、しばらくお待ちください。',
    '\r\n',
    'データの更新が出来なかった場合は、翌日に再度更新処理を行います。更新の失敗が続く場合は、ご登録いただいている証券口座情報を確認してください。',
  ],
};

const UpdateDataInfo: React.SFC = () => {
  const [showModal, setShowModal] = useState(false);
  const onInfoClick = () => setShowModal(true);
  const onClose = () => setShowModal(false);
  return (
    <div onClick={() => showModal && onClose()}>
      {showModal === true && (
        <MessageModal
          title={C_UpdateDataInfo.title}
          message={C_UpdateDataInfo.message}
          onClose={onClose}
        />
      )}

      <div
        className="flex text-justify items-center justify-center h-4 cursor-pointer"
        onClick={onInfoClick}>
        <Icon name="help_outline" />
        <div className="ml-1 text-sm">{C_UpdateDataInfo.title}</div>
      </div>
    </div>
  );
};

export default UpdateDataInfo;
